import { ReactNode } from 'react';
import { toast } from 'react-toastify';
import { ToastType } from '../enums/toast';
import Toast from '../components/Toast';

export const displayErrorToast = (error: any) => {
    let errorStr: string;

    if (typeof error === 'string') {
        errorStr = error;
    } else if(error?.response?.status === 500) {
        errorStr = error.response.statusText;
    }else if (error?.response?.data?.non_field_errors) {
        errorStr = error.response.data.non_field_errors.length === 1 ? error.response.data.non_field_errors[0] : error.response.data.non_field_errors.join(". ");
    } else if (error?.response?.data) {
        errorStr = JSON.stringify(error.response.data);
    } else if (error?.message) {
        errorStr = error.message;
    } else if (error?.detail) {
        errorStr = error.detail;
    } else if(error?.non_field_errors) {
        errorStr = JSON.stringify(error.non_field_errors);
    } else {
        errorStr = JSON.stringify(error);
    }

    displayToast(errorStr, ToastType.ERROR);
};

export const displayMessageToast = (message: string) => {
    displayToast(message, ToastType.SUCCESS);
};

export const displayToast = (message: ReactNode, type: ToastType, className?: string): void => {
    toast(
        <Toast className={className} type={type}>
            {message}
        </Toast>,{
          autoClose: 8000,
          // removes the built-in progress bar
          customProgressBar: true
        }
    );
};